"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var hooks_1 = require("../../../hooks");
var utils_1 = require("../../../pages/utils/utils");
var ConfigProvider_1 = require("../../../providers/ConfigProvider");
var either_1 = require("../../../utils/either");
var components_1 = require("../components");
var Dropdown_1 = __importDefault(require("../inputs/Dropdown"));
var UzivatelNazevDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: bold;\n  padding-bottom: 5px;\n"], ["\n  font-weight: bold;\n  padding-bottom: 5px;\n"])));
var UzivatelDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 15px;\n"], ["\n  font-size: 15px;\n"])));
var renderUzivatel = function (nazev, druh) {
    return (react_1.default.createElement(UzivatelDiv, null,
        react_1.default.createElement(UzivatelNazevDiv, null, nazev),
        react_1.default.createElement("div", null, druh)));
};
var mapUzivatel = function (uzivatel) {
    var uzivatelName = utils_1.getNameValue(uzivatel.jmeno, uzivatel.prijmeni, uzivatel.titul, uzivatel.titulZa);
    return {
        value: uzivatel.id,
        label: uzivatelName,
        render: renderUzivatel(uzivatelName, uzivatel.druhOsobyNazev),
    };
};
var SelectUzivatel = function (_a) {
    var name = _a.name;
    var _b = formik_1.useField(name), field = _b[0], helpers = _b[2];
    var isLoading = hooks_1.useBoolean();
    var adminUrl = ConfigProvider_1.useConfig().adminUrl;
    var getJSON = hooks_1.useGetJSON(adminUrl + "/UserSeek");
    var loadOptions = function (searchText) { return __awaiter(void 0, void 0, void 0, function () {
        var params, response, resp;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!searchText) return [3 /*break*/, 2];
                    isLoading.setTrue();
                    params = {
                        keyword: searchText,
                    };
                    return [4 /*yield*/, getJSON(params)];
                case 1:
                    response = _b.sent();
                    isLoading.setFalse();
                    if (either_1.isRight(response)) {
                        resp = (_a = response === null || response === void 0 ? void 0 : response.value) === null || _a === void 0 ? void 0 : _a.zaznamy.map(function (sub) { return mapUzivatel(sub); });
                        return [2 /*return*/, resp];
                    }
                    _b.label = 2;
                case 2: return [2 /*return*/, []];
            }
        });
    }); };
    return (react_1.default.createElement(components_1.Field, null,
        react_1.default.createElement(Dropdown_1.default, { isSearchable: true, name: "idUzivatele", value: field.value, placeholder: "Vyhledat u\u017Eivatele", loadOptions: loadOptions, onChange: function (val) { return helpers.setValue(val); }, loading: isLoading.value })));
};
exports.default = SelectUzivatel;
var templateObject_1, templateObject_2;
